export default {"src":"//tokenlon.im/_next/static/media/set-spotswap-pay-mode-guide-en.92fdc158.gif","height":150,"width":600};